import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Vancouver Plus',
    description:
        'Tailormade to manage all your data registers. Operate with your data predictably, securely, and at a lower cost in an intuitive, easy to navigate dashboard.',
    url: 'https://vancouverplus.com',
    email: 'hello@email.com',
    ogImage: '/images/App-Image.jpg'
}
